import React, {useState} from 'react';
import logoSpid from "../../img/icons/spid.PNG";
import Icon from "../../components/icon/Icon";
import logoRegione from "../../img/logo/regioneVeneto.PNG"
import logoSpidFondoPagina from "../../img/logo/spid.PNG"
import Spinner from "../../components/spinner/Spinner";

function Login(props) {

    const [showSpinner, setShowSpinner] = useState(false)

    function onClickSpid() {
        setShowSpinner(true)
    }

    return (
        <div style={{marginTop: "5rem"}}>
            <Spinner show={showSpinner}/>
            {/* h1 di pagina (WCAG 1.3.1): la pagina di login non aveva titolo di primo
                livello. Reso con .sr-only (bootstrap-italia) per non alterare la resa
                grafica, che inizia con il logo della Regione. */}
            <h1 className={"sr-only"}>Accedi al Registro</h1>
            <div style={{textAlign: "center", margin: "auto", width: "50%"}}>
                {/* Logo informativo: nessun testo adiacente veicola l'ente titolare. */}
                <Icon path={logoRegione} alt={"Regione del Veneto"}/>
            </div>
            <div style={{textAlign: "center", margin: "auto", width: "40%"}}>
                <span>Entra con il Sistema pubblico per la gestione dell'identità Digitale</span>
            </div>
            <button type="button" onClick={onClickSpid} style={{
                textAlign: "center",
                marginLeft: "auto", marginRight: "auto", marginBottom: "auto", marginTop: "2rem",
                width: "20%",
                background: "#06C",
                height: "60px",
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
                border: "none",
                padding: 0,
                font: "inherit",
                color: "inherit"
            }}>
                <div style={{width: "30%", borderRight: "1px solid white"}}>
                    {/* Decorativa: il testo "Entra con SPID" nello stesso bottone
                        veicola gia' l'informazione. */}
                    <Icon height={"60"} width={"60"} path={logoSpid} alt={""}/>
                </div>
                <div style={{width: "70%"}}>
                    <span style={{color: "white", fontSize: "20px"}}>Entra con SPID</span>
                </div>
            </button>
            <div style={{
                marginLeft: "auto",
                marginRight: "auto",
                marginBottom: "auto",
                marginTop: "2rem",
                width: "40%",
                textAlign: "left"
            }}>
                <span>SPID è il sistema di accesso che
                consente di utilizzare, con un'identità  digitale unica, i servizi online della pubblica amministrazione
                e dei privati accreditati.</span>
            </div>
            <div style={{
                marginLeft: "auto", marginRight: "auto", marginBottom: "auto", marginTop: "1rem",
                width: "40%", textAlign: "left"
            }}>
                <a href="#">Maggiori informazioni su SPID</a>
                <br/>
                <a href="#">Come ottenere le credenziali SPID</a>
            </div>
            <div style={{
                marginLeft: "auto", marginRight: "auto", marginBottom: "auto", marginTop: "4rem",
                width: "50%", textAlign: "center"
            }}>
                {/* Logo informativo: unico veicolo dell'informazione in questo blocco. */}
                <Icon path={logoSpidFondoPagina} alt={"SPID - Sistema Pubblico di Identità Digitale"}/>
            </div>
        </div>
    );
}

export default Login;
